import React from "react";

import { MenuItem, Select } from "@material-ui/core";

import ErrorLabel from "components/ErrorLabel";

import DownIcon from "assets/SvgIcon/DownIcon";

import { valueStrings } from "../../constants/constantStrings";

import { selectMenuProps, selectStyles } from "./select.style";

const SelectDropDown = props => {
  let { id, value, options, disabled, onChange, errorMsg, labelText, customClass } = props;
  const classes = selectStyles();
  const placeholderClass = selectMenuProps;
  customClass = customClass || "";

  const onValChange = event => {
    value = event?.target?.value;
    if (onChange) {
      onChange(event.target.value);
    }
  };

  const dropDownIcon = props => {
    let iconClasses = props.className;
    const isOpen = iconClasses.includes("MuiSelect-iconOpen");
    iconClasses = `${classes.expandIcon} ${iconClasses} ${isOpen ? "rotate" : ""}`;
    return <DownIcon classes={iconClasses} />;
  };

  return (
    <>
      <div className={customClass}>
        {labelText && (
          <label id="tag-level-type" className={`dupont-form-label ${disabled ? classes.labelDisabled : classes.label}`}>
            {labelText}
          </label>
        )}

        <Select
          id={id}
          MenuProps={placeholderClass}
          IconComponent={dropDownIcon}
          disableUnderline
          disabled={disabled}
          className={classes.input}
          multiple
          onChange={onValChange}
          value={value}
          displayEmpty={true}
          renderValue={value =>
            value?.length ? (
              Array.isArray(value) ? (
                value.join(", ")
              ) : (
                value
              )
            ) : (
              <span className={classes.placeholder}> {valueStrings.chooseOptionStr} </span>
            )
          }
        >
          {options &&
            options.map(name => (
              <MenuItem key={name} value={name} className={classes.option}>
                {name}
              </MenuItem>
            ))}
        </Select>

        {errorMsg && <ErrorLabel message={errorMsg} />}
      </div>
    </>
  );
};

export default SelectDropDown;
